import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { 
  Container, 
  Typography, 
  Paper, 
  Box, 
  CircularProgress, 
  Divider, 
  List, 
  ListItem 
} from '@mui/material';
import { userRequest } from '../requestMethods';

const GrammarTopic = () => {
  const { slug } = useParams();
  const [topic, setTopic] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGrammarTopic = async () => {
      try {
        setLoading(true);
        const response = await userRequest.get(`/grammar/topic/${slug}`, {
          headers: {
            'Accept': 'application/json'
          }
        });

        setTopic(response.data);
      } catch (err) {
        console.error('Error fetching grammar topic:', err);
        setError(err.response?.data?.error || err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGrammarTopic();
  }, [slug]);

  if (loading) {
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container sx={{ mt: 4 }}>
        <Paper sx={{ p: 3, bgcolor: '#fff3f3' }}>
          <Typography color="error" variant="h6">
            Error: {error}
          </Typography>
        </Paper>
      </Container>
    );
  }

  if (!topic) {
    return (
      <Container sx={{ mt: 4 }}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6">
            Grammar topic not found
          </Typography>
        </Paper>
      </Container>
    );
  }

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {topic.title}
        </Typography>
        
        {topic.summary && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" color="text.secondary">
              {topic.summary}
            </Typography>
          </Box>
        )}
        
        <Box sx={{ mt: 2 }}>
          <div dangerouslySetInnerHTML={{ __html: topic.content }} />
        </Box>

        {topic.examples && topic.examples.length > 0 && topic.examples[0] !== '' && (
          <>
            <Divider sx={{ my: 3 }} />
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
              Examples
            </Typography>
            <List>
              {topic.examples.map((example, index) => (
                <ListItem key={index} sx={{ pl: 0 }}>
                  {/* <ListItemText primary={`${index + 1}. ${example}`} /> */}
                  <div dangerouslySetInnerHTML={{ __html: example }} />
                </ListItem>
              ))}
            </List>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default GrammarTopic; 